import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ImageContainer = styled.img`
  display: block;
  max-width: 80%;
  height: auto;
`

export const ShineLogoFrame = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;

  svg {
    display: block;
    width: 100%;
    height: auto;
  }
`

export const TilesGrid = styled.div`
  display: grid;
  gap: ${Spacing.S8};
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  width: 100%;
`
